import axiosHttpRequest from "../axios";

async function customerWOListService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}
async function circuitListService(endpoint, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParams(
    endpoint,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}
async function createJobService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  // let listViewData = [];
  // let listViewInfo = {};
  // if (serviceData.issuccess && serviceData.Records) {
  //     listViewData = serviceData.Records;
  // }
  // listViewInfo.records = listViewData;
  // //listViewInfo.paginationInfo = serviceData.paginationinfo;

  delete configheaders.sap_name_pw;
  return serviceResponse;
}
async function createEmptyJobService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}
async function createMaintenanceJobService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );

  return serviceResponse;
}

async function searchJobService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function activeGpwisJobsListService(endpoint, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParams(
    endpoint,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}
async function customerJobsListService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewData;
}

async function circuitCyleActiveJobsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}
async function gpwisSaveJobRakeDetailsService(
  endpoint,
  param,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    param,
    postdata,
    configheaders
  );

  // let listViewData = [];
  // let listViewInfo = {};
  // if (serviceData.issuccess && serviceData.Records) {
  //     listViewData = serviceData.Records;
  // }
  // listViewInfo.records = listViewData;
  // //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return serviceResponse;
}
async function gpwisSaveJobRRDetailsService(
  endpoint,
  param,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    param,
    postdata,
    configheaders
  );

  // let listViewData = [];
  // let listViewInfo = {};
  // if (serviceData.issuccess && serviceData.Records) {
  //     listViewData = serviceData.Records;
  // }
  // listViewInfo.records = listViewData;
  // //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return serviceResponse;
}
async function gpwisSaveJobLoadingDetailsService(
  endpoint,
  param,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    param,
    postdata,
    configheaders
  );

  // let listViewData = [];
  // let listViewInfo = {};
  // if (serviceData.issuccess && serviceData.Records) {
  //     listViewData = serviceData.Records;
  // }
  // listViewInfo.records = listViewData;
  // //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return serviceResponse;
}
async function gpwisSaveJobUnloadingDetailsService(
  endpoint,
  param,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    param,
    postdata,
    configheaders
  );

  // let listViewData = [];
  // let listViewInfo = {};
  // if (serviceData.issuccess && serviceData.Records) {
  //     listViewData = serviceData.Records;
  // }
  // listViewInfo.records = listViewData;
  // //listViewInfo.paginationInfo = serviceData.paginationinfo;
  return serviceResponse;
}

async function approveJobService(endpoint, param, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    param,
    postdata,
    configheaders
  );
  return serviceResponse;
}
async function gpwisJobRakedetailsService(
  endpoint,
  param,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execPutRequestWithParams(
    endpoint,
    param,
    postdata,
    configheaders
  );
  return serviceResponse;
}
async function getGpwisJobLoadingDetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}
async function getGpwisJobUnloadingDetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

async function getGpwisJobHeaderService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

async function calculateRebateAmount(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}
async function getgpwrsdata(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

async function getgpwrsdistance(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    queryparams,
    configheaders
  );
  return serviceResponse;
}

export default {
  customerWOListService,
  circuitListService,
  createJobService,
  searchJobService,
  activeGpwisJobsListService,
  customerJobsListService,
  circuitCyleActiveJobsService,
  gpwisSaveJobRakeDetailsService,
  gpwisSaveJobRRDetailsService,
  approveJobService,
  gpwisJobRakedetailsService,
  gpwisSaveJobLoadingDetailsService,
  getGpwisJobLoadingDetailsService,
  getGpwisJobHeaderService,
  gpwisSaveJobUnloadingDetailsService,
  getGpwisJobUnloadingDetailsService,
  calculateRebateAmount,
  getgpwrsdata,
  getgpwrsdistance,
  createEmptyJobService,
  createMaintenanceJobService
};
